import { FlexModCancellationReason as GqlFlexModCancellationReason } from '@willow/graphql-iso/src/app';
import { assertNever, FlexModCancellationEvent } from '@willow/types-iso';

export const getFlexModCancellationReasonLabel = (
  reason: FlexModCancellationEvent['reason'] | GqlFlexModCancellationReason,
): string => {
  switch (reason) {
    case 'incompleteOrLatePayment':
    case GqlFlexModCancellationReason.IncompleteOrLatePayment:
      return 'Payments not made in full / on time';
    case 'missedPayment':
    case GqlFlexModCancellationReason.MissedPayment:
      return '1 or more missed payments';
    case 'latePayment':
    case GqlFlexModCancellationReason.LatePayment:
      return '1 or more late payments';
    case 'insufficientPayment':
    case GqlFlexModCancellationReason.InsufficientPayment:
      return '1 or more insufficient payments';
    case 'ineligible':
    case GqlFlexModCancellationReason.Ineligible:
      return 'No longer eligible for modification';
    default:
      assertNever(reason);
  }
};
